var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * returns a new array made of the non-intersecting items of the two given arrays,
 * it accepts comparator which is invoked to compare elements of arrays.
 *
 * @template T
 * @param {Array<T>} array1
 * @param {Array<T>} array2
 * @param {Function} comparator
 * @return {Array<T>} new filtered exclusive array1
 *
 * @example
 * xorWith([1,2,3,4], [3,4,5,6], (x,y) => x === y);
 * // returns [1,2,5,6];
 *
 */
export var xorWith = function (array1, array2, comparator) {
    var array1Copy = __spread(array1);
    var arrayOfExclusiveValues = [];
    var i;
    array2.forEach(function (secondArrayItem) {
        i = array1Copy.findIndex(function (firstArrayItem) { return comparator(secondArrayItem, firstArrayItem); });
        if (i === -1) {
            arrayOfExclusiveValues.push(secondArrayItem);
        }
        else {
            array1Copy = __spread(array1Copy.slice(0, i), array1Copy.slice(i + 1));
        }
    });
    return __spread(array1Copy, arrayOfExclusiveValues);
};
//# sourceMappingURL=xorWith.js.map